var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":_vm.width,"height":_vm.height}},[_c('path',{attrs:{"d":"M8 14 1.333 2.667h13.334z","fill":_vm.color,"fill-rule":"evenodd"}})])}
var staticRenderFns = []

export { render, staticRenderFns }